import styled, { css } from "styled-components";

interface Props {
  active?: boolean;
  success?: boolean;
  eng?: boolean;
}

export const Container = styled.div`
  width: 100%;
  background: ${(props) => props.theme.background.default};
  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1080px;
  padding: 100px 0 146px;
  background: ${(props) => props.theme.background.default};
  display: flex;
  justify-content: space-between;

  @media (max-width: 1024px) {
    display: block;
    padding: 100px 25px 70px;
  }
`;

export const TextValue = styled.div`
  margin-right: 105px;
  @media (max-width: 768px) {
    margin-right: 0px;
  }
`;
export const TextTitle = styled.div`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 150%;
  text-transform: uppercase;
  color: ${(props) => props.theme.color.default};
`;
export const TextQuestion = styled.div`
  margin-top: 40px;
  font-family: "Noto Sans KR";
  font-weight: 700;
  font-size: 28px;
  line-height: 35px;
  letter-spacing: 0.01em;
  color: ${(props) => props.theme.color.default};
  @media (max-width: 768px) {
    font-size: 24px;
    max-width: 267px;
    word-break: keep-all;
  }
`;
export const TextSelect = styled.div`
  margin-top: 22px;
  display: flex;
  /* @media (max-width: 768px) {
    margin-left: 10px;
  } */
`;
export const TextSelectDot = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  div {
    background-color: #a7a7a7;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin: 10px;
  }
`;
export const TextSelectContent = styled.div<Props>`
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 350;
  font-size: 17px;
  line-height: 32px;
  /* text-transform: uppercase; */
  color: #a7a7a7;
  word-break: keep-all;
  max-width: 280px;
  ${(props) => {
    if (props.eng) {
      return css`
        line-height: 24px;
      `;
    }
  }}
  @media (max-width: 1024px) {
    font-style: normal;
    font-size: 16px;
    line-height: 150%;
    max-width: 100%;
    ${(props) => {
      if (props.eng) {
        return css`
          line-height: 22px;
        `;
      }
    }}
  }
`;

export const FormValue = styled.div<Props>`
  margin-top: 80px;
  @media (max-width: 768px) {
    margin-top: 55px;
  }
  @media (max-width: 445px) {
    margin-top: 30px;
  }
  button {
    width: 100%;
    max-width: 610px;
    margin: 32px auto 0;
    height: 50px;
    background: #f3f1f1;
    box-shadow: 0px 2px 3px #d4d4d4;
    border-radius: 5px;
    flex: none;
    order: 5;
    flex-grow: 0;

    font-family: "Noto Sans KR";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #a7a7a7;
    cursor: no-drop;
    ${(props) => {
      if (props.success) {
        return css`
          color: ${(props) => props.theme.color.active};
          background: rgba(72, 181, 181, 0.04);
          border: 1px solid ${(props) => props.theme.color.active};
          box-shadow: 0px 2px 3px #d4d4d4;
          cursor: pointer;
        `;
      }
    }}
    @media (max-width: 768px) {
      height: 40px;
      font-size: 16px;
      line-height: 17px;
    }
  }
`;
export const InputCustom = styled.div<Props>`
  width: 100%;
  max-width: 610px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 8px auto;
  border: 0.447541px solid #a7a7a7;
  border-radius: 16.0779px;
  @media (max-width: 768px) {
    border-radius: 9.59402px;
  }
  select,
  .select {
    width: 100%;
    max-width: 610px;
    height: 64px;
    background-color: ${(props) => props.theme.background.white};
    border-radius: 16.0779px;
    /* padding: 0px 72px 0px 32px; */
    display: inline-block;
    box-sizing: border-box;
    text-align: left;
    border: none;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 24.1168px;
    line-height: 143.2%;
    color: #a7a7a7;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* ${(props) => {
      if (props.active) {
        return css`
          font-weight: 700;
        `;
      }
    }}
    &:focus-visible {
      outline: none;
    } */
    @media (max-width: 768px) {
      height: 40px;
      font-size: 14.391px;
      line-height: 143.2%;
      /* padding: 0px 48px 0px 20px; */
      border-radius: 9.59402px;
    }
    /* div:nth-child(1) {
      height: 64px;
    } */
  }
  .selected__control {
    width: 100%;
    height: 64px;
    padding: 0 62px 0 22px;
    border: none;
    border-radius: 16.0779px;
    box-shadow: none;
    display: flex;
    align-items: center;
    background: none;
    ${(props) => {
      if (props.active) {
        return css`
          background: ${(props) => props.theme.background.default};
        `;
      }
    }}
    @media (max-width: 768px) {
      height: 40px;
      font-size: 14.391px;
      line-height: 143.2%;
      padding: 0px 28px 0px 10px;
      border-radius: 9.59402px;
    }
    .selected__placeholder {
      color: red;
      font-weight: 400;
      color: #a7a7a7;
    }
    .selected__single-value {
      font-weight: 700;
      color: #a7a7a7;
    }
    .selected__indicators {
      display: none;
    }
  }
  .react-select__menu {
    padding: 0;
  }
  img {
    position: absolute;
    right: 32px;
    @media (max-width: 768px) {
      right: 16px;
      width: 13.21px;
      height: 8.92px;
    }
  }
`;

export const Select = styled.div`
  &.select {
    position: relative;
    cursor: pointer;
    max-width: 610px;
    margin: 0 auto;

    .content {
      background: ${(props) => props.theme.background.white};
      border: 0.75px solid #a7a7a7;
      border-radius: 16.0779px;
      padding: 0 23px 0 32px;
      height: 50px;
      line-height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: "Poppins";
      font-weight: 400;
      font-size: 15px;
      color: #a7a7a7;
      @media (max-width: 768px) {
        font-size: 13px;
        border-radius: 9.59402px;
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
      }

      &--selected {
        background: #f2efe8;
        color: #a49f95;
        font-weight: 700;
      }

      > img {
        width: 16.6px;
        height: 11.21px;

        @media (max-width: 768px) {
          width: 13.21px;
          height: 8.92px;
        }
      }
    }

    .option {
      border: 1px solid #a7a7a7;
      width: 100%;
      position: absolute;
      left: 0px;
      top: calc(100% + 10px);
      z-index: 2;
      padding: 10px 20px;
      background-color: ${(props) => props.theme.background.white};
      line-height: 30px;
      border-radius: 10px;
      > div {
        text-align: left;
        font-family: "Poppins";
        font-weight: 400;
        font-size: 15px;
        color: #a7a7a7;
        @media (max-width: 768px) {
          font-size: 13px;
        }
      }
      .option--selected {
        color: #a49f95;
        font-weight: 700;
      }
    }
  }
`;
